import moment from 'moment';

export function agingStatus({ active, reason, tag }: { active: boolean, reason: string, tag: string}): string {
  if(active) {
    if(tag == 'Prospect') return 'Active';
    const overideDate = moment(reason);
    if(!overideDate.isValid()) return 'Active';
    const currentDate = moment();
    if(overideDate.isAfter(currentDate)) {
      return 'Override';
    } else {
      return 'Active';
    }
  } else if(reason) {
    if(reason.includes('Manual disable') || reason.includes('Blocked')) return 'Blocked';
    if(reason.includes('aging terms')) return 'Aging Breach';
    if(reason.includes('credit ceiling')) return 'Credit Breach';
    if(reason.includes('inactivity')) return 'Inactivity';
  }
  if(!active) return 'Disabled';
  return '';
}